
import Info from './Information/Index.vue'
import EditInfo from './Information/Edit.vue'
import ContactPersonList from './ContactPerson/List.vue'
import ContactPersonAdd from './ContactPerson/Add.vue'
import ContactPersonEdit from './ContactPerson/Edit.vue'
import ContractList from './Contract/List'
import Attachment from './Attachment/List'

export default [
  {
    path: 'info',
    name: 'AgentInfo',
    component: Info
  },
  {
    path: 'info/edit',
    name: 'EditAgentInfo',
    props: true,
    component: EditInfo
  },
  {
    path: 'contact-person',
    name: 'AgentContactPersonList',
    component: ContactPersonList
  },
  {
    path: 'contact-person/add',
    name: 'AgentContactPersonAdd',
    component: ContactPersonAdd
  },
  {
    path: 'contact-person/edit',
    name: 'AgentContactPersonEdit',
    props: true,
    component: ContactPersonEdit
  },
  {
    path: 'contract',
    name: 'AgentContractList',
    component: ContractList
  },
  {
    path: 'attachment',
    name: 'Attachment',
    component: Attachment
  }
]
